export const DEFAULT_LOADER_LABEL = 'Loading…';
